import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PlacesAnalyticsStore" */ './lazyIndex'),
    { name: 'PlacesAnalyticsStore' }
);

export const lazyLoadPlacesAnalyticsCoreOperations: LazyAction<
    typeof lazyIndex.loadPlacesAnalyticsCoreOperations,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadPlacesAnalyticsCoreOperations);

export { useListUserFeatureAccessSelector } from './selectors/useListUserFeatureAccessSelector';
export { useSectionSelector } from './selectors/useSectionsSelector';
